import {
  BG,
  CN,
  CZ,
  DE,
  DK,
  EE,
  ES,
  FI,
  FR,
  GB,
  GR,
  HR,
  HU,
  IE,
  IN,
  IS,
  IT,
  JP,
  KR,
  LT,
  LV,
  MT,
  NL,
  NO,
  PL,
  PT,
  RO,
  RS,
  RU,
  SA,
  SE,
  SI,
  SK,
  TR,
} from 'country-flag-icons/react/3x2';

type LanguageInfo = {
  icon: JSX.Element;
};

export const recordLanguageIcon: Record<string, LanguageInfo> = {
  AR: { icon: <SA width={20} height={20} /> },
  BG: { icon: <BG width={20} height={20} /> },
  ZH: { icon: <CN width={20} height={20} /> },
  CZ: { icon: <CZ width={20} height={20} /> },
  DE: { icon: <DE width={20} height={20} /> },
  DK: { icon: <DK width={20} height={20} /> },
  EE: { icon: <EE width={20} height={20} /> },
  EN: { icon: <GB width={20} height={20} /> },
  ES: { icon: <ES width={20} height={20} /> },
  FI: { icon: <FI width={20} height={20} /> },
  FR: { icon: <FR width={20} height={20} /> },
  EL: { icon: <GR width={20} height={20} /> },
  HR: { icon: <HR width={20} height={20} /> },
  HU: { icon: <HU width={20} height={20} /> },
  IE: { icon: <IE width={20} height={20} /> },
  IN: { icon: <IN width={20} height={20} /> },
  IS: { icon: <IS width={20} height={20} /> },
  IT: { icon: <IT width={20} height={20} /> },
  JP: { icon: <JP width={20} height={20} /> },
  KO: { icon: <KR width={20} height={20} /> },
  LT: { icon: <LT width={20} height={20} /> },
  LV: { icon: <LV width={20} height={20} /> },
  MT: { icon: <MT width={20} height={20} /> },
  NL: { icon: <NL width={20} height={20} /> },
  NO: { icon: <NO width={20} height={20} /> },
  PL: { icon: <PL width={20} height={20} /> },
  PT: { icon: <PT width={20} height={20} /> },
  RO: { icon: <RO width={20} height={20} /> },
  RS: { icon: <RS width={20} height={20} /> },
  RU: { icon: <RU width={20} height={20} /> },
  SE: { icon: <SE width={20} height={20} /> },
  SI: { icon: <SI width={20} height={20} /> },
  SK: { icon: <SK width={20} height={20} /> },
  TR: { icon: <TR width={20} height={20} /> },
};
